interface User {
  avatar: string | null;
}

export const getUserAvatarUrl = ({ avatar }: User): string | undefined => {
  if (!avatar || avatar.indexOf('default-avatar') !== -1) {
    return undefined;
  }

  return avatar;
};
